import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import FleetMap from "../components/FleetMap";
import { PageHeader } from "../components/Table";
import { Trash, Plus } from "@phosphor-icons/react";

export default function Geofences() {
  const [gfs, setGfs] = useState([]);
  const [form, setForm] = useState({ name: "", center_lat: "19.076", center_lng: "72.877", radius_m: "1000", rule: "both" });

  const load = () => api.get("/geofences").then((r) => setGfs(r.data.geofences));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name) return toast.error("Name required");
    await api.post("/geofences", {
      name: form.name, type: "circle", center_lat: parseFloat(form.center_lat),
      center_lng: parseFloat(form.center_lng), radius_m: parseInt(form.radius_m), rule: form.rule,
    });
    toast.success("Geofence created"); setForm({ ...form, name: "" }); load();
  };

  const remove = async (id) => { await api.delete(`/geofences/${id}`); toast.success("Deleted"); load(); };

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="Geofences" subtitle={`${gfs.length} zones configured`} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 border border-border rounded-sm overflow-hidden h-[460px]">
          <FleetMap vehicles={[]} geofences={gfs} center={[21.5, 78.9]} zoom={5} />
        </div>
        <div className="space-y-4">
          <div className="bg-card border border-border rounded-sm p-4 space-y-2">
            <div className="label-caps mb-1">New Geofence</div>
            <input data-testid="gf-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Zone name" className="w-full bg-background border border-border rounded-sm px-2 py-2 text-sm" />
            <div className="grid grid-cols-2 gap-2">
              <input value={form.center_lat} onChange={(e) => setForm({ ...form, center_lat: e.target.value })} placeholder="Lat" className="bg-background border border-border rounded-sm px-2 py-2 text-sm font-mono" />
              <input value={form.center_lng} onChange={(e) => setForm({ ...form, center_lng: e.target.value })} placeholder="Lng" className="bg-background border border-border rounded-sm px-2 py-2 text-sm font-mono" />
            </div>
            <div className="grid grid-cols-2 gap-2">
              <input value={form.radius_m} onChange={(e) => setForm({ ...form, radius_m: e.target.value })} placeholder="Radius (m)" className="bg-background border border-border rounded-sm px-2 py-2 text-sm" />
              <select value={form.rule} onChange={(e) => setForm({ ...form, rule: e.target.value })} className="bg-background border border-border rounded-sm px-2 py-2 text-sm">
                {["both", "enter", "exit"].map((r) => <option key={r}>{r}</option>)}
              </select>
            </div>
            <button data-testid="gf-create" onClick={create} className="w-full flex items-center justify-center gap-1.5 bg-primary text-white font-semibold text-sm py-2 rounded-sm"><Plus size={15} weight="bold" /> Create</button>
          </div>
          <div className="bg-card border border-border rounded-sm p-2 max-h-[200px] overflow-y-auto">
            {gfs.map((g) => (
              <div key={g.id} className="flex items-center justify-between px-2 py-2 border-b border-border/50 last:border-0 text-sm">
                <span><span className="font-semibold">{g.name}</span> <span className="text-xs text-muted-foreground">· {g.radius_m}m · {g.rule}</span></span>
                <button data-testid={`gf-delete-${g.id}`} onClick={() => remove(g.id)} className="text-muted-foreground hover:text-destructive"><Trash size={15} /></button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
